import { render, staticRenderFns } from "./videoCallMeeting.vue?vue&type=template&id=24fe092e&scoped=true&"
import script from "./videoCallMeeting.vue?vue&type=script&lang=js&"
export * from "./videoCallMeeting.vue?vue&type=script&lang=js&"
import style0 from "./videoCallMeeting.vue?vue&type=style&index=0&id=24fe092e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe092e",
  null
  
)

export default component.exports